import { render } from "./LanguagesView.vue?vue&type=template&id=2befad4e&scoped=true&ts=true"
import script from "./LanguagesView.vue?vue&type=script&lang=ts"
export * from "./LanguagesView.vue?vue&type=script&lang=ts"

import "./LanguagesView.vue?vue&type=style&index=0&id=2befad4e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2befad4e"]])

export default __exports__